/* ===== lux-conf.patch.js =====
   Luxupur®: ATC nur möglich, wenn
   1) Konfigurator vollständig
   2) Bettgröße bewusst angeklickt
   Gilt nur für OrthoSleep & OrthoTop
*/
(() => {
  const path = (location.pathname || '').toLowerCase();
 const isTarget =
  path.includes('/products/luxupur-orthosleep-matratze');

  if (!isTarget) return;

  const confRoot = document.querySelector('[data-lp-conf]');
  if (!confRoot) return;

  const SIZE_EXPLICIT_KEY = 'lx_size_explicit_selected';
  let lxPendingScrollTarget = null;

  const getForm = (fromEl) => {
    if (fromEl?.form && String(fromEl.form.action || '').includes('/cart/add')) {
      return fromEl.form;
    }

    const nearest = fromEl?.closest?.('form[action*="/cart/add"]');
    if (nearest) return nearest;

    return document.querySelector('form[action*="/cart/add"]');
  };

  const getSizeFieldset = () =>
    document.querySelector('fieldset.variant-option--buttons[data-lx-bettgroesse="true"]');

  const setSizeExplicit = (val) => {
    try {
      sessionStorage.setItem(SIZE_EXPLICIT_KEY, val ? '1' : '0');
    } catch (e) {}
  };

  const isSizeExplicit = () => {
    const fs = getSizeFieldset();
    if (!fs) return false;

    const checked = fs.querySelector('input[type="radio"]:checked');
    if (!checked) return false;

    try {
      return sessionStorage.getItem(SIZE_EXPLICIT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

    const REQUIRED_BASE_PROPERTIES = [
    'Belegung',
    'Schlafposition',
    'Körperform',
    'Liegegefühl',
    'Wärmeempfinden',
    'Unterfederung',
    'Komfortwünsche',
    'Körpergröße (cm)',
    'Körpergewicht (kg)'
  ];

  const REQUIRED_P2_PROPERTIES = [
    'Matratzen-Ausführung',
    'P2 – Bettseite',
    'P2 – Schlafposition',
    'P2 – Körperform',
    'P2 – Liegegefühl',
    'P2 – Wärmeempfinden',
    'P2 – Komfortwünsche',
    'P2 – Vorname',
    'P2 – Körpergröße (cm)',
    'P2 – Körpergewicht (kg)'
  ];


  const getPropertyMap = (formArg) => {
    const form = formArg || getForm();
    const map = new Map();
    if (!form) return map;

    form.querySelectorAll('input[type="hidden"]').forEach((i) => {
      map.set(i.name, (i.value || '').trim());
    });

    return map;
  };

  const hasConfiguratorData = (formArg) => {
    const map = getPropertyMap(formArg);
    if (!map.size) return false;

    const hasAllBase = REQUIRED_BASE_PROPERTIES.every((key) => {
      const v = map.get(`properties[${key}]`);
      return !!(v && v.length);
    });

    if (!hasAllBase) return false;

    const belegung = map.get('properties[Belegung]') || '';
    if (belegung === 'Zu zweit') {
      return REQUIRED_P2_PROPERTIES.every((key) => {
        const v = map.get(`properties[${key}]`);
        return !!(v && v.length);
      });
    }

    return true;
  };

  const ensureHint = () => {
    const form = getForm();
    if (!form) return null;

    let hint = form.querySelector('.lx-atc-hint');
    if (hint) return hint;

    hint = document.createElement('div');
    hint.className = 'lx-atc-hint';
    hint.style.cssText = `
      margin: 10px 0 10px;
      padding: 10px 12px;
      border: 1px solid rgba(0,0,0,.12);
      background: rgba(0,0,0,.04);
      font-size: 14px;
      line-height: 1.35;
      border-radius: 0;
    `;
    hint.textContent =
      'Bitte zuerst den Konfigurator vollständig ausfüllen und anschließend die Bettgröße auswählen. Dann wird „In den Warenkorb“ freigeschaltet.';

    const btnContainer =
      form.querySelector('[ref="productFormButtons"]') ||
      form.querySelector('.product-form-buttons') ||
      form;

    if (btnContainer?.parentNode) {
      btnContainer.parentNode.insertBefore(hint, btnContainer);
    }

    return hint;
  };

  const showMsg = (msg) => {
    const modal = document.getElementById('lx-atc-modal');
    const modalText = document.getElementById('lx-atc-text');

    if (modal && modalText) {
      modalText.textContent = msg;
      modal.setAttribute('aria-hidden', 'false');
      return;
    }

    alert(msg);
  };

  const updateState = () => {
    const ok = hasConfiguratorData() && isSizeExplicit();
    ensureHint();

    const hint = document.querySelector('.lx-atc-hint');
    if (!hint) return;

    hint.textContent = ok
      ? '✓ Konfigurator und Bettgröße vollständig – Sie können jetzt in den Warenkorb legen.'
      : 'Bitte zuerst den Konfigurator vollständig ausfüllen und anschließend die Bettgröße auswählen. Dann wird „In den Warenkorb“ freigeschaltet.';
  };

  const watchSizeClicks = () => {
    const fs = getSizeFieldset();
    if (!fs) return;
    if (fs.dataset.lxSizeBound === '1') return;
    fs.dataset.lxSizeBound = '1';

    fs.addEventListener(
      'change',
      (e) => {
        if (e.target?.matches('input[type="radio"]')) {
          setSizeExplicit(true);
          updateState();
        }
      },
      true
    );

    fs.addEventListener(
      'click',
      (e) => {
        const label = e.target.closest('label.variant-option__button-label');
        if (!label) return;

        const input = label.querySelector('input[type="radio"]');
        if (!input) return;

        setTimeout(() => {
          if (input.checked) {
            setSizeExplicit(true);
            updateState();
          }
        }, 0);
      },
      true
    );
  };

  const blockIfNotReady = (e, fromEl) => {
    const form = getForm(fromEl);
    const hasConf = hasConfiguratorData(form);
    const hasSize = isSizeExplicit();

    if (hasConf && hasSize) return false;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    }

    let message = '';

    if (!hasConf && !hasSize) {
      message =
        'Bitte füllen Sie zuerst den persönlichen Konfigurator vollständig aus und wählen Sie anschließend Ihre gewünschte Bettgröße aus.';
      lxPendingScrollTarget = 'config';
    } else if (!hasConf) {
      message =
        'Bitte füllen Sie zuerst den persönlichen Konfigurator vollständig aus, damit wir Ihre Luxupur® Matratze korrekt fertigen können.';
      lxPendingScrollTarget = 'config';
    } else {
      message = 'Bitte wählen Sie jetzt noch Ihre gewünschte Bettgröße aus, um fortzufahren.';
      lxPendingScrollTarget = 'size';
    }

    showMsg(message);
    return true;
  };

  const isRealAtcButton = (btn) => {
    if (!btn) return false;

    return (
      btn.matches('button[name="add"]') ||
      btn.matches('button[type="submit"][name="add"]') ||
      btn.matches('input[type="submit"][name="add"]') ||
      btn.classList.contains('add-to-cart-button') ||
      btn.matches('.sticky-add-to-cart__button, .sticky-atc__button') ||
      !!btn.closest('sticky-add-to-cart') ||
      !!btn.closest('.shopify-payment-button')
    );
  };

  setSizeExplicit(false);
  window.addEventListener('pageshow', () => setSizeExplicit(false));

  document.addEventListener('DOMContentLoaded', () => {
    watchSizeClicks();
    ensureHint();
    updateState();
  });

  confRoot.addEventListener('input', updateState, true);
  confRoot.addEventListener('change', updateState, true);

  document.addEventListener(
    'change',
    (e) => {
      if (e.target?.closest?.('variant-picker')) {
        updateState();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('button, input, a');
      if (!btn) return;
      if (!isRealAtcButton(btn)) return;
      if (btn.closest('[data-lp-conf]')) return;

      blockIfNotReady(e, btn);
    },
    true
  );

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form?.matches?.('form[action*="/cart/add"]')) return;

      blockIfNotReady(e, e.submitter || form);
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const closeBtn = e.target.closest('[data-lx-atc-close]');
      if (!closeBtn) return;

      setTimeout(() => {
        if (lxPendingScrollTarget === 'config' && confRoot) {
          confRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (lxPendingScrollTarget === 'size') {
          const fs = getSizeFieldset();
          if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        lxPendingScrollTarget = null;
      }, 120);
    },
    true
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('lx-atc-modal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
});